/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
  // $(".product-form").submit((e) => {
  //   // e.preventDefault()
  //   let flg = false;
  //   $(".spb-select .custom").each((index, element) => {
  //     let selectVal = $(element).val();
  //     if (selectVal === "") {
  //       $(element).next(".spb-error").show();
  //       flg = true;
  //     }
  //   });
  //   if (flg) e.preventDefault();
  // });
console.log("READY")
  var form = document.getElementsByClassName('product-form')[0]; // form has to have ID: <form id="formID">
  form.noValidate = true;
  form.addEventListener('submit', function(event) { // listen for form submitting
    console.log("form submit")
      if (!event.target.checkValidity()) {
         event.preventDefault(); // dismiss the default functionality
         // alert('Please, select the options');
      }
  }, false);

  $(".spb-select .custom").on("change", function () {
    $(this).next(".spb-error").hide();
  });

  $("#infiniteoptions-container").on("DOMSubtreeModified", function () {
    let variant_names=$("#variant_names_hide_monogram_options").val().replace(/['"]+/g, '').replace(/\s/g, '').trim().toLowerCase().split(",");
    if ($("#is_hide_all_monogram_options").val() === "true") {
      $("option[value^='Monogram']").remove();
    }else if(variant_names[0]!==''){
      // console.log(variant_names)
      let current_selected_variant=$(".product-form__selected-value").text().replace(/['"]+/g, '').replace(/\s/g, '').trim().toLowerCase();
      if(variant_names.indexOf(current_selected_variant)!==-1){
        $("option[value^='Monogram']").hide();
      }
      $(".block-swatch").click(function () {
        // console.log($(this).find(".block-swatch__item-text").text().replace(/['"]+/g, '').trim().toLowerCase())
        let block_val=$(this).find(".block-swatch__item-text").text().replace(/['"]+/g, '').replace(/\s/g, '').trim().toLowerCase();
          if(variant_names.indexOf(block_val)!==-1){
            $("option[value^='Monogram']").hide();
          }else{
            $("option[value^='Monogram']").show();
          }
          
      })
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('.seo-text__read-more-link');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const wrapper = e.target.closest('.seo-text-wrapper');
        const text = wrapper.querySelector('.seo-text');

        text.classList.toggle('expanded');
        toggle.textContent = text.classList.contains('expanded') ? 'Read less' : 'Read more';
      });
    });
  });

class DimensionConfirmation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.requestAnimationFrame(()=>{
      // const productSection = document.querySelector("[data-section-type='product']");
      const heightInput = this.querySelector("#grill-height");
      const lengthInput = this.querySelector("#grill-length");

      const toggleButtonState = () => {
        console.log("heightInput.value", heightInput.value);
        const addToCartBtn = document.querySelector('form[action^="/cart/add"] button[type="submit"]');
        if (heightInput.value.trim() && lengthInput.value.trim()) {
          addToCartBtn.removeAttribute("disabled");
          addToCartBtn.classList.remove("button--disabled");
        } else {
          addToCartBtn.setAttribute("disabled", "disabled");
          addToCartBtn.classList.add("button--disabled");
        }
      };

      heightInput.addEventListener("input", toggleButtonState);
      lengthInput.addEventListener("input", toggleButtonState);
      document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant;
        toggleButtonState();
      });

      // Disable button on initial load
      toggleButtonState();
    });
    }
  }
  customElements.define("dimension-confirmation", DimensionConfirmation);




// Code to add the custom class to the body tag when the klaviyo pop up is enabled.



class KlaviyoStyleObserver {
  constructor() {
    this.targetClass = 'needsclick go3365855158 kl-private-reset-css-Xuajs1';
    this.bodyClass = 'klaviyo-pop-up-enabled';
    this.bodyObserver = null;
    this.styleObserver = null;
    this.fallbackInterval = null;
    // console.log('KlaviyoStyleObserver initialized');
  }

  #addPopupClass() {
    if (!document.body.classList.contains(this.bodyClass)) {
      document.body.classList.add(this.bodyClass);
      // console.log(`Added class: ${this.bodyClass}`);
    }
  }

  #removePopupClass() {
    if (document.body.classList.contains(this.bodyClass)) {
      document.body.classList.remove(this.bodyClass);
      // console.log(`Removed class: ${this.bodyClass}`);
    }
  }

  #checkElementStyle(element) {
    try {
      const style = window.getComputedStyle(element);
      const displayValue = style.display;
      // console.log(`Computed style display: ${displayValue} for element:`, element);
      if (displayValue === 'none') {
        this.#removePopupClass();
      } else {
        this.#addPopupClass();
      }
    } catch (error) {
      console.error('Error in checkElementStyle:', error);
    }
  }

  #setupStyleObserver(targetElement) {
    try {
      if (!targetElement) {
        console.warn('Target element is null in setupStyleObserver');
        return;
      }
      // console.log('Observing style for element:', targetElement);
      this.#checkElementStyle(targetElement);
      this.fallbackInterval = setInterval(() => {
        this.#checkElementStyle(targetElement);
        // console.log('Fallback interval check');
      }, 500);
      this.styleObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            // console.log('Style attribute changed:', mutation.target.getAttribute('style'));
            this.#checkElementStyle(mutation.target);
          }
        });
      });
      const styleConfig = {
        attributes: true,
        attributeFilter: ['style']
      };
      this.styleObserver.observe(targetElement, styleConfig);
      // console.log('Style MutationObserver started');
    } catch (error) {
      console.error('Error in setupStyleObserver:', error);
    }
  }

  #setupBodyObserver() {
    try {
      const existingElement = document.querySelector(`.${this.targetClass.split(' ').join('.')}`);
      if (existingElement) {
        // console.log('Target element found on init:', existingElement);
        this.#setupStyleObserver(existingElement);
      }
      this.bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (
                  node.classList.contains('needsclick') &&
                  node.classList.contains('go3365855158') &&
                  node.classList.contains('kl-private-reset-css-Xuajs1')
                ) {
                  // console.log('Target element added to DOM:', node);
                  this.#setupStyleObserver(node);
                }
                if (node.querySelectorAll) {
                  const elements = node.querySelectorAll(`.${this.targetClass.split(' ').join('.')}`);
                  elements.forEach((element) => {
                    // console.log('Nested target element added to DOM:', element);
                    this.#setupStyleObserver(element);
                  });
                }
              }
            });
          }
        });
      });
      const bodyConfig = {
        childList: true,
        subtree: true
      };
      this.bodyObserver.observe(document.body, bodyConfig);
      // console.log('Body MutationObserver started');
    } catch (error) {
      console.error('Error in setupBodyObserver:', error);
    }
  }

  init() {
    try {
      this.#setupBodyObserver();
    } catch (error) {
      console.error('Error in init:', error);
    }
  }

  stop() {
    if (this.bodyObserver) {
      this.bodyObserver.disconnect();
      // console.log('Body MutationObserver stopped');
    }
    if (this.styleObserver) {
      this.styleObserver.disconnect();
      // console.log('Style MutationObserver stopped');
    }
    if (this.fallbackInterval) {
      clearInterval(this.fallbackInterval);
      // console.log('Fallback interval stopped');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    const klaviyoObserver = new KlaviyoStyleObserver();
    klaviyoObserver.init();
  } catch (error) {
    console.error('Error initializing KlaviyoStyleObserver:', error);
  }
});
console.clear();



// Overflow X Finder script 

class OverflowChecker {
      constructor(rootElement = document.body) {
        this.rootElement = rootElement;
        this.overflowElements = [];
      }

      checkElementOverflow(element) {
        const elementRect = element.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        if (elementRect.width > viewportWidth || elementRect.right > viewportWidth || elementRect.left < 0) {
          return true;
        }
        return false;
      }

      findOverflowElements(element = this.rootElement) {
        if (this.checkElementOverflow(element)) {
          this.overflowElements.push(element);
        }

        Array.from(element.children).forEach(child => {
          this.findOverflowElements(child);
        });
      }

      reportOverflow() {
        this.overflowElements = [];
        this.findOverflowElements();

        if (this.overflowElements.length > 0) {
          console.warn('Horizontal overflow detected in the following elements:');
          this.overflowElements.forEach(el => {
            console.log(`Element: ${el.tagName.toLowerCase()} (Class: ${el.className || 'none'}, ID: ${el.id || 'none'})`);
          });
        } else {
          console.log('No horizontal overflow detected.');
        }
      }

      run() {
        this.reportOverflow();
        window.addEventListener('resize', () => this.reportOverflow());
      }
}

    const checker = new OverflowChecker();
    checker.run();

  if (!customElements.get('testimonial-slider')) {
    customElements.define('testimonial-slider', class extends HTMLElement {
      connectedCallback() {
        // Initialize after potential theme editor changes
        setTimeout(() => this.init(), 1);
      }

      init() {
        this.slider = new Swiper(this, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          effect: 'fade',
          grabCursor: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.testimonial__nav--next'),
            prevEl: this.querySelector('.testimonial__nav--prev'),
          },
        });
      }
    });
  }


// Bulk form Functionality for Palm Furniture Custom form

class BulkQuoteForm extends HTMLElement {
  constructor() {
    super();
    this.actionButton = this.querySelector('[data-action-submit]');
    this.btnText = this.querySelector('.btn-text');
    this.submit_btn_svg = this.querySelector('[data-action-submit] svg');
    this.inlineSuccessMsg = this.querySelector('[data-success-message]');
    this.detachedForm = document.getElementById('CustomerBulkQuoteForm');
    
    this.toggleOrSubmitHandler = this.handleInteraction.bind(this);
    this.formSubmitHandler = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    if (this.actionButton) {
      this.actionButton.addEventListener('click', this.toggleOrSubmitHandler);
    }
    if (this.detachedForm) {
      this.detachedForm.addEventListener('submit', this.formSubmitHandler);
    }

    // Run status evaluation sequence on initial execution
    this.checkSubmissionStatus();
  }

  disconnectedCallback() {
    if (this.actionButton) {
      this.actionButton.removeEventListener('click', this.toggleOrSubmitHandler);
    }
    if (this.detachedForm) {
      this.detachedForm.removeEventListener('submit', this.formSubmitHandler);
    }
  }

  checkSubmissionStatus() {
    const successToken = document.querySelector('[data-bulk-quote-success]');
    
    if (successToken || window.location.search.includes('contact_posted=true')) {
      // 1. Revert to default status (hide form fields)
      this.removeAttribute('open');
      
      // 2. Render the custom structured success alert box
      if (this.inlineSuccessMsg) {
        this.inlineSuccessMsg.style.display = 'block';
      }

      // 3. Reset CTA button configurations completely
      if (this.actionButton) {
        this.actionButton.type = 'button';
        this.actionButton.disabled = false;
        this.actionButton.style.opacity = '1';
      }
      if (this.btnText) {
        this.btnText.innerText = 'Request Bulk Quote (10+ Units)';
      }
      if (this.submit_btn_svg) {
        this.submit_btn_svg.style.display = 'block';
      }
    }
  }

  handleInteraction(event) {
    if (!this.hasAttribute('open')) {
      event.preventDefault();
      this.setAttribute('open', '');
      
      // Clear success banner if user attempts a second sequential request
      if (this.inlineSuccessMsg) this.inlineSuccessMsg.style.display = 'none';
      
      const firstInput = this.querySelector('#BulkQuoteForm-name');
      if (firstInput) firstInput.focus();
    } else {
      // Form is expanded. Switch button roles to invoke validation on external targets
      this.actionButton.type = 'submit';
    }
  }

  handleSubmit(event) {
    this.injectCreationDate();

    if (this.actionButton) {
      this.actionButton.disabled = true;
      this.actionButton.style.opacity = '0.7';
      if (this.btnText) this.btnText.innerText = 'Processing Inbound Request...';
      if (this.submit_btn_svg) this.submit_btn_svg.style.display = 'none';
    }
  }

  injectCreationDate() {
    if (!this.detachedForm) return;
    const existingInput = this.detachedForm.querySelector('input[name*="New customer message on"]');
    
    if (!existingInput) {
      const today = new Date();
      const formattedDate = today.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });

      const dateInput = document.createElement('input');
      dateInput.type = 'hidden';
      dateInput.name = `contact[New customer message on]`;
      dateInput.value = `${formattedDate}`;
      this.detachedForm.appendChild(dateInput);
    }
  }
}

if (!customElements.get('bulk-quote-form')) {
  customElements.define('bulk-quote-form', BulkQuoteForm);
}